export const createLomnAnalysis = /* GraphQL */ `
  mutation CreateLomnAnalysis($input: CreateLOMNAnalysisInput!) {
    createLOMNAnalysis(input: $input) {
      id
      userId
      caseName
      patientReference
      templateType
      customPrompt
      inputDocumentKeys
      processingStatus
      resultJson
      errorJson
      createdAt
      updatedAt
    }
  }
`;

export const updateLomnAnalysis = /* GraphQL */ `
  mutation UpdateLomnAnalysis($input: UpdateLOMNAnalysisInput!) {
    updateLOMNAnalysis(input: $input) {
      id
      userId
      caseName
      patientReference
      templateType
      customPrompt
      inputDocumentKeys
      processingStatus
      resultJson
      errorJson
      createdAt
      updatedAt
    }
  }
`;

export const deleteLomnAnalysis = /* GraphQL */ `
  mutation DeleteLomnAnalysis($input: DeleteLOMNAnalysisInput!) {
    deleteLOMNAnalysis(input: $input) {
      id
    }
  }
`;

export const listLomnAnalyses = /* GraphQL */ `
  query ListLomnAnalyses(
    $filter: ModelLOMNAnalysisFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listLOMNAnalyses(filter: $filter, limit: $limit, nextToken: $nextToken) {
      items {
        id
        userId
        caseName
        patientReference
        templateType
        customPrompt
        inputDocumentKeys
        processingStatus
        resultJson
        errorJson
        createdAt
        updatedAt
      }
      nextToken
    }
  }
`;
